import React from "react";
import {useSelector} from "react-redux";
import NumberFormat from "react-number-format";
import numeral from "numeral";
import {Field, useFormikContext} from "formik";
import {Checkbox, FormControlLabel, Grid, Typography} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import {Label} from "../../../components/formInputs";
import {ErrorHelper, NumberTextField, TextField} from "../../../components/formikFormInputs";
import TextFieldCommon from "../../formikFormInputs/TextFieldCommon";
import {RootState} from "../../../reducers";
import {AccountType} from "../../../constants";


export const assetsFields = [
    {
        id: "cashInBank",
        name: "cashInBank",
        label: <Label label={"Cash in Banks/Bank Products"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "primaryRealEstate",
        name: "primaryRealEstate",
        label: <Label label={"Real Estate"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "receivables",
        name: "receivables",
        label: <Label label={"Receivables"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "stockBondAndSecurity",
        name: "stockBondAndSecurity",
        label: <Label label={"Stock, Bonds and Mutual Funds"} required={false}/>,
        // label: <Label label={"Stocks, Bonds,"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "personalProperty",
        name: "personalProperty",
        label: <Label label={"Personal Property"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "businessEquity",
        name: "businessEquity",
        // label: <Label label={"Business Interest"} required={false}/>,
        label: <Label label={"Business Interest"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },

    },
    {
        id: "lifeInsuranceCashValue",
        name: "lifeInsuranceCashValue",
        label: <Label label={"FullCash Value Life Insurance"} required={false}/>,
        // label: <Label label={"Life Insurance Cash Value"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "annuities",
        name: "annuities",
        label: <Label label={"Annuities"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "otherAssets",
        name: "otherAssets",
        label: <Label label={"Other Assets Total Amount"} required={false}/>,
        component: NumberTextField,
        InputProps: {
            startAdornment: <InputAdornment disableTypography={true}
                                            position="start">$</InputAdornment>,
        },
    },
    {
        id: "otherAssetDetails",
        name: "otherAssetDetails",
        label: <Label label={"Other Assets Details"} required={false}/>,
        component: TextField,
    },
];


const Assets = () => {
    const {values, handleChange, errors}: any = useFormikContext();
    const {user} = useSelector((state: RootState) => state.auth);
    const role = user && user.role;

    const [totalValues, setTotalValues] = React.useState<number>(0);

    React.useEffect(() => {
        let total = 0;

        assetsFields.forEach((f) => {
            if (f.name === "otherAssetDetails") {
                return;
            }
            const value = values[f.name];

            total += numeral(value).value() || 0;
        });

        setTotalValues(total); // Proper usage of setter
    }, [values]);

    return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body1" component="strong"
                                className="floatLeft w100  mb10">
                        Giftor Assets
                        {
                                (role === AccountType.Multilife || role === AccountType.Individual) &&
                                <span className="floatRight">
                                    Total Assets:
                                    <NumberFormat
                                            value={totalValues || 0}
                                            displayType={"text"}
                                            thousandSeparator={true}
                                            prefix={"$"}
                                    />
                                </span>
                        }
                    </Typography>
                    <Typography variant="body1" className="floatLeft w100 mb20">
                        Fill out or verify any giftor assets below.
                        If a particular field doesn't apply you can leave it blank.
                    </Typography>
                </Grid>
                {
                    assetsFields.filter(x => !!x).map((field: any, index: number) => {
                        return (
                                <React.Fragment key={index}>
                                    {
                                            !!field.name &&
                                            <Grid item xs={12} sm={6} md={4}>
                                                <TextFieldCommon
                                                        {...field}
                                                        fullWidth
                                                        onChange={handleChange}
                                                        values={values}
                                                />

                                                <ErrorHelper errors={errors} name={field.name}/>
                                            </Grid>
                                    }
                                </React.Fragment>
                        );
                    })
                }
                <Grid item xs={12}>
                    {(role === AccountType.Multilife || role === AccountType.Individual) &&
                            <Field name="verifyAssets">
                                {({field}) => (
                                        <>
                                            <FormControlLabel
                                                    className="mb0"
                                                    control={
                                                        <Checkbox
                                                                {...field}
                                                                checked={field.value}
                                                                color="primary"
                                                                className="pt0 pl15 pb0"
                                                        />
                                                    }
                                                    label={
                                                        <Typography variant="caption">
                                                            I verify that my total assets are &nbsp;
                                                            <NumberFormat
                                                                    value={totalValues || 0}
                                                                    displayType={"text"}
                                                                    thousandSeparator={true}
                                                                    prefix={"$"}
                                                            />
                                                            .<span className="requiredHighlight">*</span>
                                                        </Typography>
                                                    }
                                            />
                                            <ErrorHelper errors={errors} name={field.name}/>
                                        </>
                                )}
                            </Field>
                    }
                </Grid>
            </Grid>
    );
};

export default Assets;